export default "__VITE_ASSET__uVznVSuq__"